import VariableGroup from "@/assets/js/variableGroup.js";
import VariableHelpers from "@/assets/js/variableHelpers.js";
import i18n from "../i18n";
export default {
    combinedVariables(state) {
      if (!state.template || !state.templateVariables) return {};
      let vars = [
        ...(state.templateVariables || []),
        ...(state.template.extraVariables.map((v) => ({
          custom: true,
          type: "Bool",
          ...v,
        })) || []),
      ].reduce((vars, v) => {
        vars[v.name] = v;
        return vars;
      }, {});
      
      return vars;
    },
    variableGroups(state, getters) {
      return new VariableGroup(VariableHelpers.groupVariables(getters.combinedVariables));
    },
    
    language(state) {
      return i18n.locale || i18n.fallbackLocale;
    },

    guideIsReady(state){  
      return state.demoGuideSteps.some(s => s.step == 1)
    },


    getInvalidSectionNames(state) {
      if(state.template){
        return state.template.sections.reduce(
          (all, current) => all.concat(Object.values({ name: current.name, id: current.id })),
          []
        );
      } else return []
    },
    // stripePublicKey(state){
    //   return state.apiUrl == "https://api.icrobotics.com/" ? "pk_live_51Jr1eALwD4JTIsAvTq4RbmMKt0JP28Z5OFl5sAZeXTcbBY4NAREMtKXCNuFksPND43VWTYgjjHuAAWG4rB8CZ0E800VPvI7Tkc" : "pk_test_51Jr1eALwD4JTIsAv0PZFSoIScykT7EM2sW5yucfntBfC3hgPsTLgHvZ5dTjIwCI8akm0jLZwfteSvZCevbEVjvan00I0KQ0jyu"
    // },
    // trialEnding(){
    //   // return new Date('January 14, 2021 23:59:59')
    //   return false
    // },
    // versionIsTrial(){
    //   // Temporary --- Sets the limitations for trial users + countdownbanner content
    //   return false
    // }
  }